module.exports = __webpack_public_path__ + "img/TS_ICON_SOLO.3fba5621.png";